import React, { useCallback, useMemo } from 'react';
import { useI18n, withI18n } from 'panda-i18n';
import cx from 'classnames';
import locale from '@/locale';
import { CnDrawer } from '../cn-drawer';
import { CnSafeArea } from '../cn-safe-area';
import { CnBadge } from '../cn-badge';
import { CnIcon } from '../cn-icon';
const ActionSheet = (props) => {
    const { visible, message, options, align: alignProps, onClick, onClose, showCancel, cancelText, maskClosable, destructiveIndex, disabledIndexes, className, ...others } = props;
    const fullWidth = true;
    const $i18n = useI18n();
    const handleOptionClick = useCallback((option, index, e) => {
        if (onClick) {
            onClick(option, index, e);
        }
        if (onClose) {
            onClose(index, e);
        }
    }, [onClick, onClose]);
    const clsPrefix = 'cn-ui-m-action-sheet';
    const buttons = useMemo(() => {
        if (!options) {
            return null;
        }
        const len = options.length;
        // @ts-ignore
        return options.map((option, index) => {
            const disabled = disabledIndexes
                ? disabledIndexes.indexOf(index) > -1
                : false;
            let content = null;
            const align = alignProps || 'center';
            if (typeof option === 'string') {
                content = (React.createElement("div", { className: `${clsPrefix}-option-text ${clsPrefix}-option--${align}` }, option));
            }
            else if (typeof option === 'object') {
                const { badge, iconType, text, badgeType } = option;
                content = (React.createElement(React.Fragment, null,
                    iconType ? (React.createElement("div", { className: `${clsPrefix}-icon` },
                        React.createElement(CnIcon, { type: iconType, size: 24 }))) : null,
                    React.createElement("div", { className: `${clsPrefix}-option-content ${clsPrefix}-option--${align}` },
                        React.createElement("div", { className: `${clsPrefix}-option-text` }, text),
                        badge ? (React.createElement(CnBadge, { className: `${clsPrefix}-badge`, count: badge, shape: badgeType === 'dot' ? 'dot' : 'normal' })) : null)));
            }
            return (React.createElement("div", { key: `${clsPrefix}-option-${index}`, onClick: (e) => {
                    if (!disabled) {
                        handleOptionClick(option, index, e);
                    }
                }, className: cx(`${clsPrefix}-option`, {
                    [`${clsPrefix}-option--destructive`]: destructiveIndex === index,
                    [`${clsPrefix}-option--disabled`]: disabled,
                    [`${clsPrefix}-option--advanced`]: typeof option === 'object' && option.iconType,
                    [`${clsPrefix}-option--last`]: index === len - 1,
                }) }, content));
        });
    }, [
        options,
        clsPrefix,
        disabledIndexes,
        destructiveIndex,
        alignProps,
        handleOptionClick,
    ]);
    const handleMaskClose = useCallback((r, e) => onClose && onClose('mask', e), [onClose]);
    const handleCancelClose = useCallback((e) => onClose && onClose('cancel', e), [onClose]);
    return (React.createElement(CnDrawer, { ...others, visible: visible, closeMode: maskClosable ? ['mask'] : [], className: cx(`${clsPrefix}-drawer`, className), placement: "bottom", onClose: handleMaskClose, noCard: true },
        React.createElement("div", { className: cx(`${clsPrefix}`, {
                [`${clsPrefix}--fullwidth`]: fullWidth,
            }) },
            message ? React.createElement("div", { className: `${clsPrefix}-msg` }, message) : null,
            React.createElement("div", { className: cx(`${clsPrefix}-option-list`) }, buttons),
            showCancel ? (React.createElement("div", { className: cx(`${clsPrefix}-option`, `${clsPrefix}-cancel`), onClick: handleCancelClose },
                React.createElement("div", { className: `${clsPrefix}-option-text` }, cancelText ||
                    $i18n.get({ id: 'Cancel', dm: '取消', ns: 'CnActionSheet' })))) : null,
            React.createElement(CnSafeArea, { className: cx(`${clsPrefix}-safe-area`, {
                    [`${clsPrefix}-safe-area--fullwidth`]: fullWidth,
                }) }))));
};
ActionSheet.displayName = 'CnActionSheet';
ActionSheet.defaultProps = {
    visible: false,
    showCancel: true,
    maskClosable: true,
};
// 由于open中调用了 ActionSheet，所以需要将 ActionSheet 前置做国际化
const CnActionSheet = withI18n(ActionSheet, { locale, _noHoc: true });
export { CnActionSheet };
